import {
  DepositOptions,
  FinanceOptions,
  PaymentOptions,
  Side,
} from './components';
import { CLASS_NAMES } from './Desktop-constants';

const ViewComponent = () => (
  <div className={CLASS_NAMES.container}>
    <Side />
    <div className={CLASS_NAMES.content}>
      <DepositOptions />
      <PaymentOptions />
      <FinanceOptions />
    </div>
  </div>
);

ViewComponent.displayName = 'PaymentMethods-Desktop-view';

export default ViewComponent;
